export interface User {
  id: number;
  login: string;
  firstName?: string;
}

export interface PlotOwner {
  id: number;
  mobile: string | null;
  uniqueId: string | null;
  cities: any | null;
  user: User;
}

export interface ServiceReq {
  id: number;
  name: string | null;
  description: string | null;
  isActive: boolean | null;
  isDeleted: boolean | null;
}

export interface ContractorType {
  id: number;
  name: string | null;
  description: string | null;
  imgUrl: string | null;
  isDeleted: boolean | null;
  isActive: boolean | null;
  companyProfileId?: number;
}

export interface Plot {
  id: number;
  plotSize: number;
  plotLocation: string;
  plotFloors: number;
  plotFacing: string;
  plotRooms: number;
  remarks: string | null;
  others: string | null;
  createDate: string;
  updateDate: string;
  status: string;
  plotOwner?: PlotOwner;
  createdBy: User;
  updatedBy: User;
  servicesReq: ServiceReq;
  contractorTypes: ContractorType;
}

export interface CompanyProfile {
  id: number;
  name: string;
  description: string | null;
  address: string;
  pincode: number;
  projects: number;
  experience: number;
  incorpotionDate: string | null;
  rating: number;
  remarks: string | null;
  companyLogo: string | null;
  imageUrl: string | null;
  createdDate: string | null;
  updatedDate: string | null;
  speciality: string;
  isActive: boolean;
  isDeleted: boolean;
  cities: { id: number; name: string | null; isActive: boolean | null; isDeleted: boolean | null; states: any | null } | null;
  createdBy: User;
  userProfile: { id: number; mobile: string | null; uniqueId: string | null; cities: any | null; user: User | null } | null;
}

export interface PlotServiceData {
  name: string;
  mobile: string;
  plot: Plot;
  files: any | null;
  plotServices: any | null;
  isBookingPaid: boolean ; 
  isRateCardApproved:boolean
  companyProfile: CompanyProfile | null; 
  plotRateCards?: any[];
  plotRateCard?: any;
   isReassigned?: boolean | null;
}


export const TABS = ["Request", "In Progress", "Completed"] as const;
export type TabType = typeof TABS[number];